import React, { useEffect, useState } from 'react'
import { supabase, getUsersByRole } from '../../supabase.config'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Input, Radio } from '@material-tailwind/react'
import AutocompleteUser from '../ManageWarehouse/AutocompleteUser'
import { PencilIcon } from '@heroicons/react/24/outline'
import AutocompleteInput from '../CreateOrder/AutocompleteInput'
import { pinCodeList } from '../../data/pinCodeData'
import toast, { Toaster } from 'react-hot-toast'
import ShippingLabel from './ShippingLabel'
import { saveOrderSupabase } from '../../actions/orderAction'

const DeliveryOrder = () => {
  const dispatch = useDispatch()
  const [base64Value, setBase64Value] = useState("");
  const navigate = useNavigate()
  const { isAuthenticated, users, userProfile } = useSelector(
    (state) => state.user
  )
  const [lrDetails, setLrDetails] = useState("manual")
  const [showLabel, setShowLabel] = useState(false)
  const [quantity, setQuantity] = useState(0)
  const [user, setUser] = useState({})
  const [userList, setUserList] = useState([])
  const [lrNumber, setLrNumber] = useState("")
  const [orderID, setOrderID] = useState("")
  const [orderList, setorderList] = useState([])
  const [dropLocation, setDropLocation] = useState({
    address: "",
    zip: "",
    consignee: "",
    city: "",
    region: "",
    phone: ""
  })
  const [pickupZone, setPickupZone] = useState("")

  const [warehouseList, setWarehouseList] = useState([])
  const [pickupLocation, setPickupLocation] = useState({})
  console.log(user)
  const fetchWarehouse = async () => {
    // Mirror CreateOrder: filter by selected client's companyName if present; else fetch all
    let query = supabase.from('warehouses').select('*')
    if (user && user.companyName) {
      query = query.ilike('company_name', `%${user.companyName}%`)
    }
    const { data, error } = await query.order('created_at', { ascending: false })
    if (error) {
      console.error('Failed to fetch warehouses', error)
      setWarehouseList([])
      return
    }
    // Fallback: if filtering by company yields no rows, fetch all so user can at least pick
    let rows = data || []
    if ((user && user.companyName) && Array.isArray(rows) && rows.length === 0) {
      const fallback = await supabase
        .from('warehouses')
        .select('*')
        .order('created_at', { ascending: false })
      if (!fallback.error && Array.isArray(fallback.data)) {
        rows = fallback.data
      }
    }
    const mapped = (rows || []).map(w => ({
      id: w.id,
      // Top-level fields used by AutocompleteInput
      name: w.name || w.pickup_name?.name || w.contact_person || '',
      pinCode: String(w.pin_code || w.pinCode || w.pincode || w.pin || ''),
      // Legacy nested shape used by UI when selected
      pickupName: { name: w.name || '', companyName: w.company_name || '' },
      city: w.city || '',
      state: w.state || '',
      country: w.country || '',
      address: w.address || '',
      personName: w.contact_person || '',
      email: '',
      phone: w.contact_number || '',
      slot: w.preferred_slot || ''
    }))
    setWarehouseList(mapped)
  }


  const fetchUsers = async () => {
    const { data, error } = await getUsersByRole('client', 'logistics')
    if (error) {
      console.error('Failed to fetch users', error)
      return
    }
    const users = (data || []).map(u => ({
      id: u.id,
      uid: u.id, // maintain compatibility with existing code
      name: u.name,
      email: u.email,
      contact: u.contact,
      companyName: u.company_name,
      gstNo: u.gst_no,
      insuranceType: u.insurance_type
    }))
    setUserList(users)
  }
  const fetchOrderList = async () => {
    const { data, error } = await supabase
      .from('orders')
      .select('id')
    if (error) {
      console.error('Failed to fetch orders for numbering', error)
      return
    }
    setorderList(data || [])
  }
  const getCityandState = (pin) => {
    pinCodeList.map((zip) => {
      if (zip.Pin === Number(pin)) {
        setDropLocation({ ...dropLocation, city: zip.FacilityCity, region: zip.FacilityState, zip: pin })

      }
    })
  }
  const handleCreateOrder = async () => {
    if (lrDetails === "manual" && lrNumber.length === 0) {
      toast.error("Please enter LR Number")
      return
    }
    else if (Object.keys(user).length === 0) {
      toast.error("Please enter Client Name")
      return
    }
    else if (Object.keys(pickupLocation).length === 0) {
      toast.error("Please enter Warehouse Location")
      return
    }
    else if (orderID.length === 0) {
      toast.error("Please enter Order ID")
      return
    }
    else if (dropLocation.consignee.length === 0 || dropLocation.address.length === 0 || dropLocation.zip.length === 0 || dropLocation.region.length === 0 || dropLocation.city.length === 0 || dropLocation.phone.length === 0) {
      toast.error("Please enter All Delivery Details")
      return
    }
    else {
      const date = new Date()
      const data = {
        ident: "",
        createdAt: date,
        pickup_location: pickupLocation,
        dropoff_location: dropLocation,
        return_address: dropLocation,
        d_mode: "Prepaid",
        purchaseCharge: 0,
        salesCharge: 0,
        orderStatus: "preCreated",
        payment_mode: "Prepaid",
        rov_insurance: user?.insuranceType,
        invoices: [],
        weight: "",
        suborders: [],
        dimensions: [],
        consignee_gst_tin: "",
        seller_gst_tin: "",
        cb: {},
        orderID: orderID,
        lrno: (lrDetails === "automatic") ? String(date.getFullYear()) + String((date.getMonth() <= 9 ? "0" + date.getMonth() : date.getMonth())) + String((date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())) + String((Number(orderList.length) + 1)) : lrNumber,
        totalLength: "",
        totalWidth: "",
        totalHeight: "",
        masterAWB: "",
        uid: user?.uid,
        userName: user?.name,
        orderActivity: [{
          status: "Order Pre-created",
          remark: "Order has been Pre-created",
          location: "",
          time: date
        }]
      }
      // Map to Supabase orders schema
      const payload = {
        user_id: data?.uid || null,
        order_id: data?.orderID || null,
        order_number: data?.lrno || data?.orderID || null,
        pickup_address: JSON.stringify(data?.pickup_location || {}),
        delivery_address: JSON.stringify(data?.dropoff_location || {}),
        pickup_contact: data?.pickup_location?.phone || null,
        delivery_contact: data?.dropoff_location?.phone || null,
        package_details: JSON.stringify({
          invoices: data?.invoices,
          suborders: data?.suborders,
          orderActivity: data?.orderActivity,
          cb: data?.cb,
          rov_insurance: data?.rov_insurance,
          payment_mode: data?.payment_mode,
          d_mode: data?.d_mode,
          purchaseCharge: data?.purchaseCharge,
          salesCharge: data?.salesCharge,
          masterAWB: data?.masterAWB,
          userName: data?.userName
        }),
        weight: data?.weight || null,
        dimensions: JSON.stringify(data?.dimensions || []),
        shipping_partner: null,
        tracking_number: data?.lrno || null,
        status: data?.orderStatus || 'preCreated',
        total_amount: data?.salesCharge || null
      }
      await dispatch(saveOrderSupabase({
        createdAt: data.createdAt,
        pickup_location: data.pickup_location,
        dropoff_location: data.dropoff_location,
        d_mode: data.d_mode,
        purchaseCharge: data.purchaseCharge,
        salesCharge: data.salesCharge,
        orderStatus: data.orderStatus,
        payment_mode: data.payment_mode,
        rov_insurance: data.rov_insurance,
        invoices: data.invoices,
        weight: data.weight,
        suborders: data.suborders,
        dimensions: data.dimensions,
        consignee_gst_tin: data.consignee_gst_tin,
        seller_gst_tin: data.seller_gst_tin,
        cb: data.cb,
        orderID: data.orderID,
        lrno: data.lrno,
        totalChargeableWeight: 0,
        masterAWB: data.masterAWB,
        uid: data.uid,
        userName: data.userName,
        orderActivity: data.orderActivity,
      }))
      setShowLabel(true)

    }
  }
  console.log(lrDetails)

  useEffect(() => {
    // Always load warehouses so pickup list is available immediately
    fetchWarehouse()
   
  }, [user])
  useEffect(() => {
    // Always load warehouses so pickup list is available immediately
    fetchWarehouse()
    console.log(warehouseList)
    if (Object.keys(user).length !== 0) {
      fetchOrderList()
    }
    fetchUsers()
  }, [])

  return (
    <>
      {!showLabel && <div className='py-4 bg-white' >
        <Toaster />
        <h3 className='text-center text-[1.5rem] font-[GilroyBold]' >Create New Order</h3>
        <div className='my-6 mx-[20px]' >
          <div className=''  >
            <h4 className='font-[GilroyMedium]' >LR Details</h4>
            <div className='ml-[-10px]' >
              <Radio defaultChecked={true} onChange={(e) => setLrDetails(e.target.value)} value="manual" name='type' label="Manual" />
              <Radio onChange={(e) => setLrDetails(e.target.value)} value="automatic" name='type' label="Automatic" />
            </div>
            <div className='w-full my-2' >
              <Input value={lrNumber} onChange={(e) => setLrNumber(e.target.value)} disabled={lrDetails === "automatic" ? true : false} label='Enter LR No' />
            </div>
          </div>
          <div className='my-6' >
            <h4 className='font-[GilroyMedium]' >Shipment Details</h4>

            <div className='flex-wrap gap-3 flex items-center justify-start  my-2' >
              <div className='w-full max-w-[350px]' >
                {Object.keys(user).length === 0 ? <AutocompleteUser selected={user} setSelected={setUser} placeholder="Enter Client Name" data={userList} /> : <div>
                  <div className=' flex items-center justify-end' >
                    <PencilIcon className='w-[25px] cursor-pointer' onClick={() => setUser({})} />
                  </div>
                  <h3 className='text-[.8rem]' >{user.name}, {user.email}</h3>
                  <h3 className='text-[.8rem]' >{user.companyName}</h3>

                </div>}
              </div>
              <div className='w-full max-w-[350px]' >
                {Object.keys(pickupLocation).length === 0 ? <AutocompleteInput selected={pickupLocation} setSelected={setPickupLocation} placeholder="Enter Pickup Location" data={warehouseList} /> : <div>
                  <div className=' flex items-center justify-end' >
                    <PencilIcon className='w-[25px] cursor-pointer' onClick={() => setPickupLocation({})} />
                  </div>
                  <h3 className='text-[.8rem]' >{pickupLocation?.pickupName?.name}, {pickupLocation.pinCode}</h3>
                  <h3 className='text-[.8rem]' >{pickupLocation.address}, {pickupLocation.city}, {pickupLocation.state}</h3>

                </div>}
              </div>


              <div className='w-full max-w-[350px]'>
                <Input value={orderID} onChange={(e) => setOrderID(e.target.value)} label='Enter Order ID' />
              </div>
              <div className='w-full max-w-[350px]'>
                <Input type='number' value={quantity} onChange={(e) => setQuantity(e.target.value)} label='No of Boxes' />
              </div>

            </div>
          </div>
          <h4 className='font-[GilroyMedium]' >Delivery Details</h4>
          <div className='flex items-center flex-wrap my-3 justify-start gap-4' >

            <div className='w-full'>
              <Input value={dropLocation.consignee} onChange={(e) => setDropLocation({ ...dropLocation, consignee: e.target.value })} label='Consignee' />
            </div>
            <div className='w-full'>
              <Input type='number' value={dropLocation.phone} onChange={(e) => setDropLocation({ ...dropLocation, phone: e.target.value })} label='Contact No' />
            </div>
            <div className='w-full'>
              <Input value={dropLocation.address} onChange={(e) => setDropLocation({ ...dropLocation, address: e.target.value })} label='Address' />
            </div>
            <div className='w-full'>
              <Input value={dropLocation.zip} onChange={(e) => {
                setDropLocation({ ...dropLocation, zip: e.target.value })
                getCityandState(e.target.value)
              }} label='Pincode' />
            </div>
            <div className='w-full'>
              <Input value={dropLocation.city} onChange={(e) => setDropLocation({ ...dropLocation, city: e.target.value })} label='City' />
            </div>
            <div className='w-full'>
              <Input value={dropLocation.region} onChange={(e) => setDropLocation({ ...dropLocation, region: e.target.value })} label='State' />
            </div>

          </div>
          <div className='' >
            <Button onClick={handleCreateOrder} className='w-full' >Book</Button>
          </div>
        </div>
      </div>}
      <div>
        {
          showLabel &&
          <ShippingLabel quantity={quantity} lrNumber={lrNumber} pickupLocation={pickupLocation} dropLocation={dropLocation} />

        }
      </div>
    </>
  )
}

export default DeliveryOrder
